import useTranslation from 'next-translate/useTranslation'

import { ProductType } from '@/ts/Product'
import SectionHeading from '@/views/common/SectionHeading'

function HowToParticipate({ type }: HowToParticipateProps) {
  const { t } = useTranslation('products')

  if (type !== 'Product::FansiClass') return null

  return (
    <div className="mt-8 space-y-3 md:mt-12">
      <SectionHeading text={t('how_to_participate')} />
      <p>{t('how_to_participate_instruction')}</p>
    </div>
  )
}

interface HowToParticipateProps {
  type: ProductType
}

export default HowToParticipate
